import { useNavigate } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { ReceiveCustomerClaimForm } from "@/features/customer-claims/receive-customer-claim-form";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const CreateReceiveCustomerClaim = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      // Extract sellerId for header, remove it from payload
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("customer-claims/claim", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate("/sales/customer-claims/receive");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat klaim terima barang"));

      throw error;
    }
  };

  return (
    <PageContainer maxWidth="xl" title="Buat Klaim Terima Barang">
      <ReceiveCustomerClaimForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </LoadingButton>
        )}
      />
    </PageContainer>
  );
};
